import React, { memo } from 'react';
import styled from 'styled-components';

import { mediumMediaQuery, smallMediaQuery } from '../../../common/utilities/sizeHelpers';
import { DisplayAdWidget } from '../../ads/displayAdWidget.jsx';
import { AqiPartnerLogo } from '../../common/icons/aqiPartnerLogo';
import { HealthAdvice } from './healthAdvice';
import { AqiSummarySectionAdWrapper } from './styles';
import { TopTriggers } from './topTriggers';
import { DisplayAdUnit } from '../../../containers/ads/displayAdUnitContainer';

const whiteFill = '#fff';

interface AirQualitySummarySectionProps {
    isDesktop: boolean;
    isMobile: boolean;
}

export const AirQualitySummarySection = memo(({ isDesktop, isMobile }: AirQualitySummarySectionProps) => {
    return (
        <SectionWrapper>
            <AqiSummaryWrapper>
                <Container>
                    <TopTriggers />
                    <HealthAdvice />
                </Container>
                <AqiPartnerLogoContainer>
                    <AqiPartnerLogo 
                        width={!isMobile ? 175 : 128} 
                        height={!isMobile ? 44 : 32} 
                        fillThree={whiteFill} 
                        fillFour={whiteFill}
                    />
                </AqiPartnerLogoContainer>
            </AqiSummaryWrapper>
            {
                !isDesktop
                    && <AqiSummarySectionAdWrapper >
                        <DisplayAdUnit 
                            slotId={isMobile ? 'air-quality_summaryarticle_x13' : 'air-quality_summaryarticle_x16'} 
                            width={300} 
                            height={isMobile ? 250 : 600} 
                        /> 
                    </AqiSummarySectionAdWrapper>
            }
        </SectionWrapper>
    );
});

AirQualitySummarySection.displayName = 'AirQualitySummarySection';

const SectionWrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;

    @media ${smallMediaQuery} {
        flex-direction: column;
    }
`;

const Container = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: auto;

    @media ${mediumMediaQuery} {
        flex-direction: column;
        justify-content: flex-start;
    }

    @media ${smallMediaQuery} {
        flex-direction: column;
        justify-content: flex-start;
    }
`;

const AqiSummaryWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    @media ${mediumMediaQuery} {
        margin-right: 8px;
    }
`;

const AqiPartnerLogoContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 16px;
    height: 44px;
    @media ${smallMediaQuery} {
        height: 35px;
    }
`;
